// extracted by mini-css-extract-plugin
export var container = "_tc-0";
export var table = "_tc-2";
export var tableWrapper = "_tc-1";